import React from 'react';
import { defineMessages, InjectedIntlProps, injectIntl } from 'react-intl';
import styled from 'styled-components';

import ProductAdvancedSearchLinks from './ProductAdvancedSearchLinks';

const Wrapper = styled.div`
  margin-top: 32px;
  text-align: center;
`;

type Props = {
  searchTerm: string;
} & InjectedIntlProps;

const StillNotFound = ({ searchTerm, intl }: Props) => {
  const title = intl.formatMessage(messages.notFoundOnResults);

  return (
    <Wrapper>
      <h5>{title}</h5>
      <ProductAdvancedSearchLinks searchTerm={searchTerm} hasResults />
    </Wrapper>
  );
};

export default injectIntl(StillNotFound);

const messages = defineMessages({
  notFoundOnResults: {
    defaultMessage: "Still can't find what you are looking?",
    description:
      'title shown when searching for a term on your work and finding results but not finding what you are looking for specifically',
    id: 'uchi.notFoundOnResults',
  },
});
